app.service("ProductSolutionService", ['$rootScope', 'ProductService', 'DoorTypeService',
    function ($rootScope, ProductService, DoorTypeService) {

        const service = this;

        const siteHelper = $rootScope.site_helper;
        const modelConstructor = $rootScope.model_constructor;

        const ProductSolutionModel = modelConstructor.extend(ProductService.BasicProductModel, {
            id: "product_solution",
            base_component_id: "solution",
            request_range_id: null,
            default_colour_id: null,
            has_m2m: false,
            dataResponseHandler: dataResponseHandler,
            dataSortHandler: dataSortHandler,
            isValidAcquiredObject: isValidAcquiredObject,
            applyItemHandler: applyItemHandler,
            overhang_colour_exceptions: {},
            solution_journey_option_terms: null,
            categories: {
                parent: [],
                alpha: [],
                beta: [],
                unit: [],
                width: []
            }
        });

        this.factory = new ProductService.BasicProductModelFactory({
            birth: function (values) {
                return new ProductSolutionModel(values);
            },

            validVariationPointers: function (variationIDs) {
                return ['browse_id', 'solution_id', 'assembly_id', 'door_type_id', 'request_range_id', 'site_range_id', 'style_id', 'colour_id'];
            },

            applyModelVariation: applyModelVariation
        });

        function applyModelVariation(model) {

            this.super(model);

            const baseComponentCache = model.base_component_cache;
            if (!baseComponentCache) {
                return;
            }

            const variationIDs = model.variation_ids;

            const siteRangeID = variationIDs.site_range_id;
            const styleID = variationIDs.style_id;

            const solutionID = variationIDs.solution_id;
            const assemblyID = variationIDs.assembly_id;

            const siteRange = siteRangeID ? $rootScope.factory.site_range.getModel(variationIDs).choices[siteRangeID] : null;
            const hasM2M = !!siteRange && !!siteRange.m2m;
            let defaultColourID = null;
            let requestRangeID = model.request_range_id;
            if (!requestRangeID) {
                requestRangeID = "valore"; //tod. no I should be handling this elsewhere
                defaultColourID = "alabaster";
            }


            siteHelper.applyValues(model, {
                request_range_id: requestRangeID,
                default_colour_id: defaultColourID,
                inner_drawer_request_range_id: null,
                inner_colour_id: null,
                inner_style_id: null,
                tallstor_match_id: null,
                solution_id: solutionID,
                assembly_id: assemblyID,
                has_m2m: hasM2M
            });

            const simulatedProducts = {};
            for (let productID in baseComponentCache.products) {
                const cachedProduct = getCachedProduct(baseComponentCache, productID, styleID);
                if (validateProduct(model, cachedProduct)) {
                    simulatedProducts[productID] = cachedProduct;
                }
            }

            model.buildAcquiredChoices(simulatedProducts);

            model.categories = service.createCategories(model.choiceList());
        }

        function getCachedProduct(baseComponentCache, productID, styleID) {
            if (!baseComponentCache || !baseComponentCache.products) {
                return {};
            }
            let cachedProduct = baseComponentCache.products[productID];
            if (!cachedProduct) {
                return {};
            }
            if (!styleID || !cachedProduct.style_state || !cachedProduct.style_state[styleID]) {
                return cachedProduct;
            }
            cachedProduct = JSON.parse(JSON.stringify(cachedProduct));
            const styleState = cachedProduct.style_state[styleID]
            delete cachedProduct.style_state;
            for (let key in styleState) {
                cachedProduct[key] = styleState[key];
            }
            return cachedProduct;
        }

        function validateProduct(model, product) {


            const variationIDs = model.variation_ids;

            const solutionID = variationIDs.solution_id;
            const assemblyID = variationIDs.assembly_id;
            const doorTypeID = variationIDs.door_type_id;
            const siteRangeID = variationIDs.site_range_id;
            const styleID = variationIDs.style_id;
            const colourID = variationIDs.colour_id;

            if (solutionID) {
                if (!product.solution_ids || !product.solution_ids.includes(solutionID)) {
                    return false;
                }
            }
            if (assemblyID) {
                if (!product.assembly_ids || !product.assembly_ids.includes(assemblyID)) {
                    return false;
                }
            }

            if (solutionID === "bedroom_flat_pack") {
                if (product.tags.includes("robe") && !product.tags.includes(doorTypeID)) {
                    return false;
                }
            }


            if (siteRangeID && product.site_range) {

                const inSiteRange = product.site_range[siteRangeID];
                if (!inSiteRange) {
                    return false;
                }
                if (styleID && inSiteRange.style_exceptions && inSiteRange.style_exceptions.includes(styleID)) {
                    return false;
                }
                if (colourID && inSiteRange.colour_exceptions && inSiteRange.colour_exceptions.includes(colourID)) {
                    return false;
                }
            }

            return true
        }


        function isValidAcquiredObject(acquiredObject) {

            if (!this.super(acquiredObject)) {
                return false;
            }

            const model = this.root;
            const baseComponentCache = model.base_component_cache;
            if (!baseComponentCache) {
                return false;
            }

            if (acquiredObject.is_placeholder) {
                return true;
            }
            const styleID = model.variation_ids.style_id;

            const cachedProduct = getCachedProduct(baseComponentCache, acquiredObject.id, styleID);
            if (!cachedProduct) {
                return false;
            }

            return validateProduct(this.root, cachedProduct)
        }

        function applyItemHandler(product) {
            this.super(product);

            const model = this.root;
            const styleID = model.variation_ids.style_id;
            const cachedProduct = getCachedProduct(model.base_component_cache, product.id, styleID);

            for (let key in cachedProduct) {
                let value = cachedProduct[key];
                if (siteHelper.isObject(value) || siteHelper.isArray(value)) {
                    value = JSON.parse(JSON.stringify(value));
                }
                if (key === "tags") {
                    const currentTags = product[key];
                    for (let i = 0; i < currentTags.length; i++) {
                        const tag = currentTags[i];
                        if (value.indexOf(tag) === -1) {
                            value.push(tag)
                        }
                    }
                }
                product[key] = value;
            }

            if(product.tags.indexOf("handleless") !== -1 && product.tags.indexOf("bedroom") !== -1){
                product.tags.splice(product.tags.indexOf("bedroom"), 1);
            }


            let readableDescription;


            const isSingleWardrobe = product.tags && product.tags.indexOf('single_wardrobe') !== -1;
            const hingeHoleOptions = $rootScope.service.product.getHingeHoleOptions(product);

            const isCorneredImageRequired = !!cachedProduct.img_src;

            if (model.assembly_id !== "rigid") {
                readableDescription = product.description;
            } else {
                readableDescription = product.rigid_description;
                delete product.confirmation_required_message; //todo. temporary fix. Will need a permanent solution from Phil
            }

            let productCanRotateGrain = true;
            if (product._items) {
                for (let i = 0; i < product._items.length; i++) {
                    const item = product._items[i];
                    if (item.type === "door") {
                        if (item.height && item.height > 1200) {
                            productCanRotateGrain = false;
                        }
                    }
                }
            }

            product.local_option_term_config = getLocalOptionTermConfig(model, product);

            product.group_name = getGroupName(product);
            if (product.width && isNaN(product.width)) {
                product.width = 0;
            }
            if (product.height && isNaN(product.height)) {
                product.height = 0;
            }
            if (product.tags.indexOf('pack_to_order') !== -1) {
                if (model.assembly_id !== "rigid") {

                    product.lead_time_corner_strip = "days-10";
                }
            }

            if (product.tags.indexOf('boiler') !== -1) {
                product.height_title = "Door Height";
                product.width_title = "Door Width";
            }

            if (product.tags.indexOf('coming_soon') !== -1) {
                product.coming_soon = true;
                product.prominent_disabled = true;
                product.green_notice = "Coming Soon";
            }

            if (product.tags.indexOf('back_soon') !== -1) {
                product.back_soon = true;
                product.prominent_disabled = true;
                product.green_notice = "Back Soon";
            }

            if (product.out_of_stock_message || product.disabled || product.coming_soon || product.back_soon) {
                product.no_atc = true;
            }

            if (product.out_of_stock_message) {//we may sometimes get an 'out_of_stock_message' that matches a 'notice' being sent
                product.notice = product.out_of_stock_message;
            }

            siteHelper.applyValues(product, {
                quantity: 1,
                hide_price: true,
                option_layout: "list",
                is_cornered_image_required: isCorneredImageRequired,
                readable_description: readableDescription,
                is_single_wardrobe: isSingleWardrobe,
                hinge_hole_options: hingeHoleOptions,
                product_can_rotate_grain: productCanRotateGrain,
                rotate_grain: false,
                overhang_colour_exceptions: product.overhang ? model.overhang_colour_exceptions : {},
                solution_id: model.solution_id ? model.solution_id : product.solution_id,
                assembly_id: model.assembly_id ? model.assembly_id : product.assembly_id,

                collectImageParams: function () {
                    const params = this.super();
                    params.image_type_id = "product";
                    params.site_range_id = "bella";
                    params.api_code = "complete";
                    params.unit = product.id;
                    params.width = 500;
                    params.height = 500;
                    return params;
                },
                displayImgSrc: function () {
                    return product.getImgSrc();
                },
                canRotateGrain: function () {
                    return product.product_can_rotate_grain && $rootScope.navigation_model.state_values.colour_grain;
                },
                currentGrainDirection: function () {
                    let colourGrain = $rootScope.navigation_model.state_values.colour_grain;
                    if (!colourGrain) {
                        return null;
                    }
                    colourGrain = colourGrain.toLowerCase();
                    if (!product.rotate_grain) {
                        return colourGrain
                    }
                    return colourGrain === "horizontal" ? "vertical" : "horizontal";
                },
                currentGrainName: function () {
                    const grainDirection = product.currentGrainDirection()
                    return grainDirection ? (grainDirection === "horizontal" ? "Horizontal" : "Vertical") + " Grain" : null;
                },

                finalPrice: function () {
                    return finalPrice(product);
                },
            });
        }

        service.genericOptionTermConfig = function (variationIDs) {
            //todo I need a variable for this form phil. I could use  not '_component_only' but I reckon it won't be accurate
            const clicboxConfig = {
                option_id: "clicbox_colour"
            }
            const hingeColourConfig = {
                option_id: "hinge_colour"
            }
            const drawerColourConfig = {
                option_id: "drawer_colour"
            }
            const solutionID = variationIDs.solution_id;
            const doorTypeID = variationIDs.door_type_id;

            if (solutionID === "bedroom_flat_pack") {

                if (doorTypeID === "sliding") {
                    return [clicboxConfig];
                }
                return [clicboxConfig, hingeColourConfig];
            }
            return [clicboxConfig, hingeColourConfig, drawerColourConfig];
        }

        function getLocalOptionTermConfig(model, product) {

            if (!model.has_a_completed_request) {
                return [];
            }

            product.requires_hettich_colour = true;

            const localOptionTermConfig = [];
            const genericOptionTermConfig = service.genericOptionTermConfig(model.variation_ids);
            for (let i = 0; i < genericOptionTermConfig.length; i++) {
                const optionID = genericOptionTermConfig[i].option_id;
                if (optionID === "drawer_colour" && !product.requires_hettich_colour) {
                    continue;
                }
                if (optionID === "hinge_colour" && !product.requires_hinge_colour) {
                    continue;
                }
                localOptionTermConfig.push({
                    option_id: optionID
                })
            }

            if (product.overhang) {
                localOptionTermConfig.push({
                    option_id: "overhang"
                })
            }

            localOptionTermConfig.sort(function (a, b) {
                if (a.required && !b.required) {
                    return -1;
                }
                if (!a.required && b.required) {
                    return 1;
                }
                return 0
            })

            return localOptionTermConfig;
        }

        function dataResponseHandler(data) {
            let i;

            const acquiredObjects = data.units ? data.units : []

            const overhangColourExceptions = {};
            if (data.overhang_colour_exceptions) {
                for (i = 0; i < data.overhang_colour_exceptions.length; i++) {
                    overhangColourExceptions[data.overhang_colour_exceptions[i]] = true;
                }
            }
            for (i = 0; i < acquiredObjects.length; i++) {
                const acquiredObject = acquiredObjects[i];
                acquiredObject.overhang_colour_exceptions = acquiredObject.overhang ? overhangColourExceptions : {};
            }

            return acquiredObjects;
        }

        function dataSortHandler(arrayProducts) {
            arrayProducts.sort(function (a, b) {
                if (a.m2m && !b.m2m) {
                    return -1;
                }
                if (!a.m2m && b.m2m) {
                    return 1;
                }
                if (a.sort_index < b.sort_index) {
                    return -1;
                }
                if (a.sort_index > b.sort_index) {
                    return 1;
                }
                const aName = a.name ? a.name.toUpperCase() : "";
                const bName = b.name ? b.name.toUpperCase() : "";
                if (aName < bName) {
                    return -1;
                }
                if (aName > bName) {
                    return 1;
                }
                return 0;
            })
        }

        function getGroupName(product) {
            const componentObject = $rootScope.service.cache_local_server.getComponentObject(product.base_component_id);
            if (componentObject && product.alpha_category_ids) {
                for (let i = 0; i < product.alpha_category_ids.length; i++) {
                    const alphaCategory = componentObject.alpha_category[product.alpha_category_ids[i]];
                    if (alphaCategory) {
                        return alphaCategory.name;
                    }
                }
            }
            return product.name;
        }

        function finalPrice(product) {
            return product.calculated_price ? product.calculated_price : 0;
        }

        this.createCategories = function (productChoiceList, includeParentCategoryIDs) {

            const baseComponentCache = $rootScope.model.cache_local_server.component.solution;
            const parentCachedCategory = [];
            const alphaCachedCategory = [];
            let betaCachedCategory = [];
            let unitCachedCategory = [];
            let widthCachedCategory = [];
            if (baseComponentCache) {

                const validAlphaCategoryIDs = [];
                for (let i = 0; i < baseComponentCache.parent_category_order.length; i++) {
                    const categoryID = baseComponentCache.parent_category_order[i];
                    const category = baseComponentCache.parent_category[categoryID];
                    if (includeParentCategoryIDs && includeParentCategoryIDs.length && !includeParentCategoryIDs.includes(category.id)) {
                        continue;
                    }
                    parentCachedCategory.push(category);
                    if (category.alpha_category) {
                        for (let alphaCategoryID in category.alpha_category) {
                            if (!validAlphaCategoryIDs.includes(alphaCategoryID)) {
                                validAlphaCategoryIDs.push(alphaCategoryID);
                            }
                        }
                    }
                }
                for (let i = 0; i < baseComponentCache.alpha_category_order.length; i++) {
                    const categoryID = baseComponentCache.alpha_category_order[i];
                    const category = baseComponentCache.alpha_category[categoryID];
                    if (validAlphaCategoryIDs.includes(categoryID)) {
                        alphaCachedCategory.push(category);
                    }
                }
                betaCachedCategory = baseComponentCache.beta_category_list;
                unitCachedCategory = baseComponentCache.unit_category_list;
                widthCachedCategory = baseComponentCache.width_category_list;
            }

            const parentCategoryIDs = [];
            const alphaCategoryIDs = [];
            const betaCategoryIDs = [];
            const unitCategoryIDs = [];
            const widthCategoryIDs = [];

            for (let i = 0; i < productChoiceList.length; i++) {
                const product = productChoiceList[i];

                for (let j = 0; j < product.parent_category_ids.length; j++) {
                    const parentCategoryID = product.parent_category_ids[j];
                    if (parentCategoryIDs.indexOf(parentCategoryID) === -1) {
                        parentCategoryIDs.push(parentCategoryID)
                    }
                }
                for (let j = 0; j < product.alpha_category_ids.length; j++) {
                    const alphaCategoryID = product.alpha_category_ids[j];
                    if (alphaCategoryIDs.indexOf(alphaCategoryID) === -1) {
                        alphaCategoryIDs.push(alphaCategoryID)
                    }
                }
                for (let j = 0; j < product.beta_category_ids.length; j++) {
                    const betaCategoryID = product.beta_category_ids[j];
                    if (betaCategoryIDs.indexOf(betaCategoryID) === -1) {
                        betaCategoryIDs.push(betaCategoryID)
                    }
                }
                if (unitCategoryIDs.indexOf(product.unit_category_id) === -1) {
                    unitCategoryIDs.push(product.unit_category_id)
                }
                if (widthCategoryIDs.indexOf(product.width_category_id) === -1) {
                    widthCategoryIDs.push(product.width_category_id)
                }
            }

            const parentCategories = [];
            const alphaCategories = [];
            const betaCategories = [];
            const unitCategories = [];
            const widthCategories = [];

            const alphaCategoriesObject = {};
            for (let i = 0; i < alphaCachedCategory.length; i++) {
                let alphaCategory = alphaCachedCategory[i];
                if (alphaCategoryIDs.indexOf(alphaCategory.id) === -1) {
                    continue;
                }
                alphaCategory = JSON.parse(JSON.stringify(alphaCategory));
                alphaCategory.product_ids = [];
                for (let j = 0; j < productChoiceList.length; j++) {
                    const product = productChoiceList[j];
                    if (product.alpha_category_ids.indexOf(alphaCategory.id) !== -1) {
                        alphaCategory.product_ids.push(product.id);
                    }
                }
                alphaCategories.push(alphaCategory);
                alphaCategoriesObject[alphaCategory.id] = alphaCategory;
            }

            for (let i = 0; i < betaCachedCategory.length; i++) {
                let betaCategory = betaCachedCategory[i];
                if (betaCategoryIDs.indexOf(betaCategory.id) === -1) {
                    continue;
                }
                betaCategory = JSON.parse(JSON.stringify(betaCategory));
                betaCategory.product_ids = [];
                for (let j = 0; j < productChoiceList.length; j++) {
                    const product = productChoiceList[j];
                    if (product.beta_category_ids.indexOf(betaCategory.id) !== -1) {
                        betaCategory.product_ids.push(product.id);
                    }
                }
                betaCategories.push(betaCategory);
            }

            for (let i = 0; i < unitCachedCategory.length; i++) {
                let unitCategory = unitCachedCategory[i];
                if (unitCategoryIDs.indexOf(unitCategory.id) === -1) {
                    continue;
                }
                unitCategory = JSON.parse(JSON.stringify(unitCategory));
                unitCategory.product_ids = [];
                unitCategory.width_category_product_ids = {};
                for (let j = 0; j < productChoiceList.length; j++) {
                    const product = productChoiceList[j];
                    if (product.unit_category_id === unitCategory.id) {
                        unitCategory.product_ids.push(product.id);
                        if (!unitCategory.width_category_product_ids[product.width_category_id]) {
                            unitCategory.width_category_product_ids[product.width_category_id] = [];
                        }
                        unitCategory.width_category_product_ids[product.width_category_id].push(product.id);
                    }
                }
                unitCategories.push(unitCategory);
            }

            for (let i = 0; i < widthCachedCategory.length; i++) {
                let widthCategory = widthCachedCategory[i];
                if (widthCategoryIDs.indexOf(widthCategory.id) === -1) {
                    continue;
                }
                widthCategory = JSON.parse(JSON.stringify(widthCategory));
                widthCategory.product_ids = [];
                for (let j = 0; j < productChoiceList.length; j++) {
                    const product = productChoiceList[j];
                    if (product.width_category_id === widthCategory.id) {
                        widthCategory.product_ids.push(product.id);
                    }
                }
                widthCategories.push(widthCategory);
            }

            for (let i = 0; i < parentCachedCategory.length; i++) {
                let parentCategory = parentCachedCategory[i];
                if (parentCategoryIDs.indexOf(parentCategory.id) === -1) {
                    continue;
                }
                parentCategory = JSON.parse(JSON.stringify(parentCategory));
                parentCategory.alpha_category_ids = [];
                parentCategory.beta_category_ids = [];
                parentCategory.unit_category_ids = [];
                parentCategory.width_category_ids = [];
                parentCategory.product_ids = [];

                const parentAlphaCategoryIDs = [];
                const parentBetaCategoryIDs = [];
                const parentUnitCategoryIDs = [];
                const parentWidthCategoryIDs = [];
                for (let j = 0; j < productChoiceList.length; j++) {
                    const product = productChoiceList[j];
                    if (product.parent_category_ids.indexOf(parentCategory.id) !== -1) {
                        parentCategory.product_ids.push(product.id);
                        for (let k = 0; k < product.alpha_category_ids.length; k++) {
                            const alphaCategoryID = product.alpha_category_ids[k];
                            if (parentCategory.alpha_category && parentCategory.alpha_category[alphaCategoryID]) {
                                parentAlphaCategoryIDs.push(alphaCategoryID);
                            }
                        }
                        for (let k = 0; k < product.beta_category_ids.length; k++) {
                            const betaCategoryID = product.beta_category_ids[k];
                            if (parentBetaCategoryIDs.indexOf(betaCategoryID) === -1) {
                                parentBetaCategoryIDs.push(betaCategoryID);
                            }
                        }
                        if (parentUnitCategoryIDs.indexOf(product.unit_category_id) === -1) {
                            parentUnitCategoryIDs.push(product.unit_category_id);
                        }
                        if (parentWidthCategoryIDs.indexOf(product.width_category_id) === -1) {
                            parentWidthCategoryIDs.push(product.width_category_id);
                        }
                    }
                }
                for (let j = 0; j < alphaCachedCategory.length; j++) {
                    const alphaCategory = alphaCachedCategory[j];
                    if (parentAlphaCategoryIDs.indexOf(alphaCategory.id) !== -1) {
                        parentCategory.alpha_category_ids.push(alphaCategory.id)
                    }
                }
                for (let j = 0; j < betaCachedCategory.length; j++) {
                    const betaCategory = betaCachedCategory[j];
                    if (parentBetaCategoryIDs.indexOf(betaCategory.id) !== -1) {
                        parentCategory.beta_category_ids.push(betaCategory.id)
                    }
                }
                for (let j = 0; j < unitCachedCategory.length; j++) {
                    const unitCategory = unitCachedCategory[j];
                    if (parentUnitCategoryIDs.indexOf(unitCategory.id) !== -1) {
                        parentCategory.unit_category_ids.push(unitCategory.id)
                    }
                }
                for (let j = 0; j < widthCachedCategory.length; j++) {
                    const widthCategory = widthCachedCategory[j];
                    if (parentWidthCategoryIDs.indexOf(widthCategory.id) !== -1) {
                        parentCategory.width_category_ids.push(widthCategory.id)
                    }
                }
                parentCategories.push(parentCategory);
            }

            return {
                parent: parentCategories,
                alpha: alphaCategories,
                beta: betaCategories,
                unit: unitCategories,
                width: widthCategories
            }
        }


    }])